import { useEffect } from "react";
import { createParserConfig } from "../../../services/parserConfigService";
import { getConnectionTypeList } from "../../../services/connectionTypeService";
import { getPayloadTypeList } from "../../../services/payloadTypeService";
import { fetchList } from "../../../utils/fetchList";
import { useParserConfigFormState } from "./useParserConfigFormState";

export const useParserConfigCreate = (open: boolean, deviceTypeId: number) => {
  const form = useParserConfigFormState();

  useEffect(() => {
    if (!open) return;
    fetchList(getConnectionTypeList, form.setConnectionTypes);
    fetchList(getPayloadTypeList, form.setPayloadTypes);
  }, [open]);

  const handleCreate = async () => {
    const { parserName, selectedConnectionType, selectedPayloadType, description } = form;
    if (!parserName || !selectedConnectionType || !selectedPayloadType) {
      throw new Error("Lütfen tüm alanları doldurun");
    }

    const response = await createParserConfig({
      parserName,
      description,
      connectionTypeId: selectedConnectionType.id,
      payloadTypeId: selectedPayloadType.id,
      ...(deviceTypeId !== undefined && { deviceTypeId }),
    });

    if (!response.data.success) throw new Error(response.data.message);
    return response.data.message;
  };

  return { ...form, handleCreate };
};
